'use client';

import { useState } from 'react';
import { IconButton } from 'src/components/PulseUI/IconButton';
import { useProspectSelection } from 'src/context/prospects';
import { RemoveProvidersDialog } from 'src/modules/Lists/components';
import { faTrashCanXmark } from '@fortawesome/pro-solid-svg-icons';

interface GridProviderDeleteButtonProps {
  table?: string;
}

const GridProviderDeleteButton = ({
  table = '',
}: GridProviderDeleteButtonProps) => {
  const {
    state: [selectionModel],
  } = useProspectSelection();

  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  return (
    <>
      <IconButton
        id={`${table}-provider-delete-button`}
        size="sm"
        variant="outlined"
        color="danger"
        sx={{
          fontWeight: 900,
        }}
        onClick={() => setShowDeleteDialog(true)}
        disabled={!selectionModel.length}
        icon={faTrashCanXmark}
        circular
      />
      <RemoveProvidersDialog
        open={showDeleteDialog}
        onClose={() => setShowDeleteDialog(false)}
      />
    </>
  );
};

export default GridProviderDeleteButton;
